import React, { type PropsWithChildren } from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import type { container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key } from '@atlassian/jira-relay/src/__generated__/container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner.graphql';
import { MaybeMemoConditionalFormattingEntryPointProvider } from '../../controllers/entrypoint-context/index.tsx';

/** @deprecated Duplicate any changes made here to ConditionalFormattingSidebarContainerInner within issue-navigator/conditional-formatting-sidebar package */
export const ConditionalFormattingInner = ({
	project,
	children,
}: PropsWithChildren<{
	project: container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key | null;
}>) => {
	const projectData =
		useFragment<container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key>(
			// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
			graphql`
				fragment container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner on JiraProject
				@argumentDefinitions(first: { type: "Int!" }) {
					key
					...entrypointContext_issueNavigatorActionConditionalFormatting_ConditionalFormattingEntrypointProvider
						@arguments(first: $first)
				}
			`,
			project,
		);

	if (projectData?.key != null) {
		return (
			<MaybeMemoConditionalFormattingEntryPointProvider
				project={projectData}
				projectKey={projectData.key}
			>
				{children}
			</MaybeMemoConditionalFormattingEntryPointProvider>
		);
	}

	return children;
};

/** @deprecated Duplicate any changes made here to ConditionalFormattingSidebarContainer within issue-navigator/conditional-formatting-sidebar package */
export const ConditionalFormatting = ({
	isEnabled,
	...rest
}: PropsWithChildren<{
	isEnabled?: boolean;
	project: container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner$key | null;
}>) => {
	if (isEnabled && fg('jira_list_conditional_formatting')) {
		return <ConditionalFormattingInner {...rest} />;
	}
	return rest.children;
};
